import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Header } from '../components/Header';
import { MainRoutes } from '../containers';

export default function RouterNavigate() {
  return (
    <BrowserRouter>
      <Header />
      <MainRoutes />
    </BrowserRouter>
  );
}
